import { Link } from 'react-router';
import { OWNER_LABEL, ROLE_LABELS } from '@bingo/shared';
import { useAuth } from '../lib/auth';
import { useT } from '../lib/i18n';
import { IconAccount, IconSettings, IconTransfers, IconUsers } from '../components/Icons';

/** Phone menu for the screens that do not fit in the bottom bar. */
export function More() {
  const { me, logout } = useAuth();
  const t = useT();
  if (!me) return null;
  return (
    <div className="stack">
      <div className="page-head"><h1>{t('More')}</h1></div>
      <nav className="card more-list" aria-label={t('More')}>
        <Link to="/transfers"><IconTransfers /> {t('Transfers')}</Link>
        {me.user.role === 'direction' && <Link to="/settings"><IconSettings /> {t('Lists')}</Link>}
        {me.user.role === 'direction' && <Link to="/users"><IconUsers /> {t('Users')}</Link>}
        <Link to="/account"><IconAccount /> {t('My account')} <span className="muted">{t('language, theme, password')}</span></Link>
      </nav>
      <div className="card section">
        <div className="who">
          <b>{me.user.name}</b>
          <span className="muted">{t(me.owner ? OWNER_LABEL : ROLE_LABELS[me.user.role])} · v {me.version}</span>
        </div>
        <button className="btn" onClick={logout}>{t('Log out')}</button>
      </div>
    </div>
  );
}
